import React from 'react';
import { connect } from 'react-redux';
import { AppState } from '@Redux/store';
import Repeater from '@Utils/Repeater';
import ArsenalUnitRow from '@Builder/myArsenal/army/make/ArsenalUnitRow';
import { ArsenalUnitView } from '@Selectors/arsenal/make/view/ArsenalUnitView';
import { arsenalArmyPresenter } from '@Selectors/arsenal/make/arsenalArmyPresenter';
import { Breadcrumb, BreadcrumbItem, Col, Row } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { defaultMessages } from '@I18n/default';
import CreateArsenalUnit from './new/create-army-list-unit';
import MultiColorProgressBar from '@Builder/myArsenal/army/utils/multi-color.progress-bar';

const ArsenalArmyMake: React.FC<ArsenalMakeProps> = ({ army }) => {
  const currentLocale = document.documentElement.lang;

  return <>
    <Breadcrumb tag="nav">
      <BreadcrumbItem tag="a" href={`/${currentLocale}/builder/army_lists`}><i
        className="fa-solid fa-house"></i></BreadcrumbItem>
      <BreadcrumbItem tag="span" active>{army.name}</BreadcrumbItem>
    </Breadcrumb>

    <Row className="justify-content-center arsenal">
      <h2 className="col-12 text-center">
        <FormattedMessage {...defaultMessages.arsenalArmyShowTitle} /><br /><em>{army.name}</em></h2>
      <Col xs={5} md={4} lg={3} xl={2}>
        <CreateArsenalUnit />
      </Col>
      <Col xs={7} md={8} lg={9} xl={10} className=" army_list_units_overview">
        <MultiColorProgressBar readings={army.readings} />
        <Repeater data={army.units} indexPrefix="arsenal-army-unit">
          {
            (item: ArsenalUnitView) => <ArsenalUnitRow unit={item} />
          }
        </Repeater>
      </Col>
    </Row>
  </>;
};

const mapStateToProps = (state: AppState) => ({
  army: arsenalArmyPresenter(state)
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ArsenalArmyMake);

type ArsenalMakeProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>